import { gqlClient } from '@/utilities/graphQLClient';
import { gql } from '@/utilities/gql';

export const queryFn = async ({
  gridViewId,
  limit,
  offset,
}: {
  gridViewId: number;
  limit: number;
  offset: number;
}) => {
  const response = await gqlClient.request(
    gql(`
      query TrendingStocks($gridViewId: Float!, $limit: Int!, $offset: Int!) {
        companyPredefinedScreenerResults(
          input: { gridViewId: $gridViewId, limit: $limit, offset: $offset }
        ) {
          companies {
            name
            tickerSymbol
            canonicalURL
            info {
              url
            }
            country {
              iso2
            }
          }
        }
      }
    `),
    { gridViewId, limit, offset }
  );

  if ('companyPredefinedScreenerResults' in response) {
    return response.companyPredefinedScreenerResults?.companies || [];
  }
};
